import { useState } from 'react';
import { scrollToId } from '../App';
import '../css/Header.css'
import { useNavigate, useLocation } from "react-router-dom";

const Header = ({i18n, t, text, lang}) => {
    const [showLang, setShowLang] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const changeLang = (lang) => {
        i18n.changeLanguage(lang);

        const pathParts = location.pathname.split('/');

        pathParts[1] = lang;

        navigate(pathParts.join('/'));
    }

    return(
        <div className='header'>
            <div onClick={() => (scrollToId(navigate, location, 'start'))}>B.R.V.</div>
            <div>
                <div onClick={() => (scrollToId(navigate, location, 'fleet'))}>{text['fleet'][lang]}</div>
                <div onClick={() => (scrollToId(navigate, location, 'reserve_block'))}>{text['book_now'][lang]}</div>
                <div onClick={() => (scrollToId(navigate, location, 'routes'))}>{text['routes'][lang]}</div>
                <div onClick={() => (scrollToId(navigate, location, 'why_us'))}>{text['why_us'][lang]}</div>
                <div onClick={() => (scrollToId(navigate, location, 'footer'))}>{text['contact'][lang]}</div>
            </div>
            <div className='language_container'>
                <div className={`language_button ${i18n.language === 'en' ? "active_language" : ""}`} onClick={() => changeLang("en")}>EN</div>
                <div className={`language_button ${i18n.language === 'geo' ? "active_language" : ""}`} onClick={() => changeLang("geo")}>GEO</div>
                <div className={`language_button ${i18n.language === 'ru' ? "active_language" : ""}`} onClick={() => changeLang("ru")}>RU</div>
            </div>
            <div className='mobile_switcher' onClick={() => {setShowLang(!showLang)}}></div>
            {showLang === true && (
                <div className='language_container_mobile'>
                    <div className={`language_button ${i18n.language === 'en' ? "active_language" : ""}`} onClick={() => {changeLang("en");
                        setShowLang(!showLang);
                    }}>EN</div>
                    <div className={`language_button ${i18n.language === 'geo' ? "active_language" : ""}`} onClick={() => {changeLang("geo");
                        setShowLang(!showLang);
                    }}>GEO</div>
                    <div className={`language_button ${i18n.language === 'ru' ? "active_language" : ""}`} onClick={() => {changeLang("ru");
                        setShowLang(!showLang);
                    }}>RU</div>
                </div>
            )}
        </div>
    )
}

export default Header;